import type { MetadataRoute } from "next";
export const dynamic = "force-static";
export default function robots(): MetadataRoute.Robots { return {rules:{userAgent:"*",allow:"/"},sitemap:"https://ncore-3d-platform.pijunyel2.chatgpt.site/sitemap.xml"}; }
